import {AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export class PasswordMatchedValidators {
  static match(controlName: string, checkControlName: string) {
    return (formGroup: UntypedFormGroup) => {
      const control = formGroup?.controls[controlName];
      const checkControl = formGroup?.controls[checkControlName]
      if (checkControl.errors && !checkControl.errors['matching']) {
        return;
      }
      if (control.value !== checkControl.value) {
        checkControl.setErrors({ matching: true });
      } else {
        checkControl.setErrors(null);
      }
    };
  }

  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl) => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }
}
